import { Component, OnInit } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {ApiService} from '../services/api.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: 'app-webinar',
  templateUrl: './webinar.component.html',
  styleUrls: ['./webinar.component.css']
})
export class WebinarComponent implements OnInit {
  webnarHostInfoList: any;
  userId: any;
  userName: any;
  webnarAttendList: any;
  webinarMembersList:any;
  getWebinarID: any;
  update:any;
  webinarIdforUpdate: any;

  constructor(
    private router: Router,
    private modalService: NgbModal,
    public ApiServiceCall: ApiService
  ) {
    // this.accessToken = localStorage.getItem('accessToken');
    this.userId = localStorage.getItem('userID');
    this.userName = localStorage.getItem('userName');
    // this.hostInfo = [];
    // this.attendInfo = [];
    this.webnarHostInfoList=[];
    this.webnarAttendList=[];
    this.webinarMembersList = [];
    this.getWebinarID;
    this.update = {};
    // this.meetingMembersList=[];
    // this.webinarMembersList=[];
  }

  ngOnInit(): void {
    this.getAllWebinarHostList();
    this.getAllWebnarAttendList();
  }

getAllWebinarHostList(){
  var obj = {userId:this.userId};
  this.ApiServiceCall.getAllHostedList(obj).subscribe((data) => {

    console.log(data.responseValue);
    let myWebnarList = data.responseValue;
    for (let i=0;i<myWebnarList.length;i++)
    {
      if(myWebnarList[i]['isWebinar'] == '1')
      {
      this.webnarHostInfoList.push(myWebnarList[i]);
      console.log("Vishnu",this.webnarHostInfoList );
      }
    }

});
}
getAllWebnarAttendList(){
  var obj = {userId:this.userId};
  this.ApiServiceCall.getAllAttendList(obj).subscribe((data) => {

    console.log(data.responseValue);
    let myWebnarAttendData = data.responseValue;
    for (let i=0;i<myWebnarAttendData.length;i++)
    {
      if(myWebnarAttendData[i]['isWebinar'] == '1')
      {
      this.webnarAttendList.push(myWebnarAttendData[i]);
      }
    }

});
}

getMembersList2(webinarId){
  var obj = {id:webinarId};
  console.log(obj);
  // $('.loading-overlay').addClass('is-active');
    this.ApiServiceCall.getMemberOfWebinarList(obj).subscribe((data) => {
      // $('.loading-overlay').removeClass('is-active');
      console.log("Vishnu");
      console.log(data.responseValue);
      this.webinarMembersList = data.responseValue;
      console.log(this.webinarMembersList);

    });
  }

  delete(component,item) {
    this.getWebinarID=item;
    console.log('DeleteWebinar', this.getWebinarID);
    this.modalService.open(component);
  }

  onDeleteWebinar(){
    var obj ={
      isWebinar:1,
      id: this.getWebinarID.webinarId,
      userId:localStorage.getItem("userID")
    }
    console.log("DeleteWebinar"+ JSON.stringify(obj));
    this.ApiServiceCall.deleteWebinar(obj).subscribe((data) => {
      // this.webnarAttendList.slice(this.webnarAttendList.indexOf(this.getWebinarID),1);
      this.webnarHostInfoList.slice(this.webnarHostInfoList.indexOf(this.getWebinarID.webinarId),1);
      this.modalService.dismissAll();
      console.log(data.responseMessage);
        // alert('success');
    });


  }
  toOfflineWebinar(){
    this.router.navigate(['/offlinewebinar']);
    // [routerLink]="['/offlinewebinar']"

  }

  startWebinar(roomId,takeBy,takenByName,roomName,refId){


    var isAdmins = 0;

        if(takeBy == JSON.parse(localStorage.getItem('userID')))
        {
            isAdmins = 1;
        }
        else
        {
          isAdmins = 0;
        }
        var obj = {userId:this.userId,
          referenceId : refId,
          'isWebinar' : '1',
          'isStarted' : '1',
          'accessTokenId' : '',
          'logDateTime' :  new Date()

        };
        console.log(obj);
        // $('.loading-overlay').addClass('is-active');
          this.ApiServiceCall.insertUserTransactionLog(obj).subscribe((data) => {
            // $('.loading-overlay').removeClass('is-active');
            //alert(data);
            if(data.responseCode == '1')
            {
              localStorage.setItem('roomId',JSON.stringify(roomId));
              localStorage.setItem('isAdmin',JSON.stringify(isAdmins));
              localStorage.setItem('takeBy',JSON.stringify(takeBy));
              localStorage.setItem('takenByName',JSON.stringify(takenByName));
              localStorage.setItem('roomName',JSON.stringify(roomName));
              localStorage.setItem('refId',JSON.stringify(refId));
              window.open("/corncallweb/#/videoorom", '_blank');
            }
else{
  alert('Saving Log Failed');

}
          });



    //window.open('/videoorom', '_blank')
   // this.router.navigate(['/videoorom']);
    // [routerLink]="['/offlinewebinar']"

  }
  toLiveWebinar(){
    this.router.navigate(['/livewebinar']);
    // [routerLink]="['/livewebinar']"
  }
  onUpdate(content2,item) {
    this.webinarIdforUpdate = item.webinarId
    this.modalService.open(content2);
    this.update = item;
    console.log("Vishnu",this.update);
  }
  onUpdateWebinar(){
    var obj = {
      isWebinar:1,
      id:this.webinarIdforUpdate,
      eventName:this.update.eventName,
      startDateTime:this.update.startDate+ ' ' + this.update.startTime + ':00',
      endDateTime:this.update.endDate + ' ' + this.update.endTime + ':00',
  }

   this.ApiServiceCall.updateWebinar(obj).subscribe((data) => {

     alert(data.responseMessage);
       this.modalService.dismissAll();




   });

 }




}
